import React, {Component} from 'react';
import ReactPlayer from "react-player";

const Meditate =()=> {
    return(
        <ReactPlayer
            url="https://www.youtube.com/watch?v=inpok4MKVLM"
        />
    )
}
export default Meditate;